import { CalendarBlank, SealCheck } from "@phosphor-icons/react";
import moment from "moment";
import React from "react";
import DateRangePicker from "../../components/Date/DateRangePicker";
import Section from "../../components/Section";
import { Button, ISelectInput, MaskInput, Popover, Tab, Tabs, Typography } from "payzli-ui";
import Styles from "./DateRangePopup.module.css";
import { floating_dates_list, getDateRange } from "./helper";
const DateRangePopup = () => {
	const [selectedTab, setSelectedTab] = React.useState("custom");
	const [floatingDate, setFloatingDate] = React.useState<ISelectInput>();
	const [startDate, setStartDate] = React.useState<moment.Moment | null>(null);
	const [endDate, setEndDate] = React.useState<moment.Moment | null>(null);
	const [dateInput, setDateInput] = React.useState({ startDate: "", endDate: "" });
	const handleDateChange = (startDate: moment.Moment | null, endDate: moment.Moment | null) => {
		console.log("startDate", startDate);
		console.log("endDate", endDate);
		setStartDate(startDate);
		setEndDate(endDate);
	};
	const TargetButton = () => (
		<Button
			className={Styles.target_btn}
			iconPosition="left"
			label="Select Dates"
			onClick={() => {}}
			leftIcon={<CalendarBlank weight="bold" />}
			variant="secondary"
		/>
	);
	const handleChangeTab = (event: any, tab: string) => {
		setSelectedTab(tab);
	};
	const handleChangeDateInput = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		if (e.target.name === "start-date") {
			setDateInput({ ...dateInput, startDate: value });
		} else {
			setDateInput({ ...dateInput, endDate: value });
		}
		if (!value.includes("_")) {
			e.target.name === "start-date" ? handleDateChange(moment(value), endDate ?? null) : handleDateChange(startDate, moment(value));
		}
	};
	const handleSelectFloatingDate = (selectedDate: ISelectInput) => {
		setFloatingDate(selectedDate);
		console.log("selectedDate", selectedDate);
		const date_range: any = getDateRange(selectedDate.value);
		console.log("date_range", date_range);
		handleDateChange(moment(date_range.start_date), moment(date_range.end_date));
		setDateInput({ startDate: date_range.start_date, endDate: date_range.end_date });
	};
	return (
		<Section title="# Date Range Select Popup">
			<div className="d-flex justify-content-end">
				<Popover handlePopupVisible={() => {}} parentClass={`${Styles.popup_container} p-0 mt-1`} position="bottom" target={<TargetButton />}>
					<div className={Styles.popup_header}>
						<Tabs className="w-100" fullwidth={true} onChange={handleChangeTab} size="sm" type="tertiary" value={selectedTab}>
							<Tab
								badge={<SealCheck size={"1rem"} weight="fill" className="icon_verified" />}
								label="True up only"
								value="trueuponly"
								className="justify-content-center"
								badgeClassName={Styles.verified_badge_icon}
							/>
							<Tab label="Custom" value="custom" className="justify-content-center" />
						</Tabs>
					</div>
					<div className={Styles.popup_body}>
						<div className={Styles.left_sidebar}>
							{floating_dates_list.map((item) => (
								<div
									onClick={() => handleSelectFloatingDate(item)}
									key={item.value}
									aria-selected={item.value === floatingDate?.value}
									className={Styles.floating_date_item}
								>
									<Typography type="text" size="sm" fontFamily="medium" color="secondary">
										{item.label}
									</Typography>
								</div>
							))}
						</div>
						<div className={Styles.date_range}>
							<DateRangePicker
								onDateChange={handleDateChange}
								format="YYYY-MM-DD"
								isDoubleCalender={true}
								isRangePicker={true}
								value={{ startDate: startDate, endDate: endDate }}
								className="p-3"
							/>
							<div className={Styles.date_range_popup_footer}>
								<div className={Styles.custom_date_field}>
									<MaskInput
										id={"start-date"}
										name={"start-date"}
										value={dateInput.startDate}
										onChange={handleChangeDateInput}
										formClass={Styles.date_input}
										required={false}
										formSubmitted={false}
										label={""}
										placeholder="Start Date"
										mask="_"
										format="####-##-##"
										className={""}
									/>
									<Button className="cursor-default" label="-" onClick={() => {}} variant="none" />
									<MaskInput
										id={"end-date"}
										name={"end-date"}
										value={dateInput.endDate}
										onChange={handleChangeDateInput}
										formClass={Styles.date_input}
										required={false}
										formSubmitted={false}
										label={""}
										placeholder="End Date"
										mask="_"
										format="####-##-##"
										className={""}
									/>
								</div>
								<div className="">
									<Button label="Cancel" onClick={() => {}} variant="secondary" />
									<Button label="Apply" onClick={() => {}} variant="primary" className="ml-3" />
								</div>
							</div>
						</div>
					</div>
				</Popover>
			</div>
		</Section>
	);
};

export default DateRangePopup;
